/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import {
  string,
  node,
  bool,
} from 'prop-types';
import {
  FormHeading,
  Heading,
  Icon,
  Collapsible,
} from 'components/common';
import './CoverCard.scss';

class CoverCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: !props.expanded,
    };

    this.toggleCover = this.toggleCover.bind(this);
  }

  toggleCover() {
    const { isCollapsed } = this.state;

    this.setState({ isCollapsed: !isCollapsed });
  }

  render() {
    const {
      title,
      subheading,
      description,
      icon,
      children,
    } = this.props;
    const {
      isCollapsed,
    } = this.state;

    return (
      <div className="cover-card">
        <FormHeading title={title} description="" />
        <div className={isCollapsed ? 'cover collapsed' : 'cover active'} onClick={this.toggleCover}>
          <img className="cover-icon" alt="" src={icon} />
          <div className="cover-text">
            <Heading as="h3">{subheading}</Heading>
            <div className="cover-description">
              {description}
            </div>
          </div>
          <Icon name={isCollapsed ? 'chevron_down' : 'chevron_up'} primary />
        </div>
        <Collapsible isCollapsed={isCollapsed} className="cover-card-children">
          {children}
        </Collapsible>
      </div>
    );
  }
}

CoverCard.propTypes = {
  title: string.isRequired,
  subheading: string,
  description: string.isRequired,
  icon: string,
  children: node,
  expanded: bool,
};

CoverCard.defaultProps = {
  icon: '',
  subheading: '',
  children: null,
  expanded: false,
};

export default CoverCard;
